import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = { class: "w-full flex justify-between items-center" }
const _hoisted_3 = { class: "capitalize" }
const _hoisted_4 = { class: "md:flex items-center gap-3 relative" }
const _hoisted_5 = {
  key: 0,
  ref: "ActionOptions",
  class: "bg-white w-72 py-2 shadow-md rounded-md absolute top-12 right-0 z-50"
}
const _hoisted_6 = { class: "text-[14px]" }
const _hoisted_7 = { class: "text-[14px] ml-1" }
const _hoisted_8 = { class: "w-full mt-8 bg-[#F8F9FA] rounded-md border-[1px] border-[#D0D0D1]" }
const _hoisted_9 = { class: "w-full bg-white h-[60px] border-b-2 flex" }
const _hoisted_10 = { class: "font-[700]" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "font-[700]" }, "Chat", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_QuizAnswer = _resolveComponent("QuizAnswer")!
  const _component_QuizChat = _resolveComponent("QuizChat")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t("labels.generic", { pt: "Questões", en: "Questions" })), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          label: _ctx.$t('labels.generic', { pt: 'Baixar', en: 'Download' }),
          icon: "pi pi-download",
          class: "p-button-sm btn-primary h-8",
          loading: _ctx.btnLoading,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openActionOptions()))
        }, null, 8, ["label", "loading"]),
        (_ctx.showActionOptions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_Button, {
                id: "add-user-btn",
                class: "btn-simple p-button-sm w-full gap-2 flex items-center",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadQuizQuestions()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { name: "md-quiz" }),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Questões das avaliações",
                  en: "Quiz questions",
                })), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                id: "download-template-btn",
                class: "btn-simple p-button-sm w-full gap-2 flex items-center",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadQuizQuestions()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { name: "md-textsms" }),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Questões do chat",
                  en: "Chat questions",
                })), 1)
                ]),
                _: 1
              })
            ], 512))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => {
            _ctx.quizPaginated(true);
            _ctx.loader = true;
          }),
          class: _normalizeClass(`h-full w-[150px] flex justify-center items-center bg-transparent border-b-2 ${
            _ctx.quizAnswer
              ? ' border-h-primary-500 text-h-primary-500'
              : 'border-[#0000] text-neutral-400'
          }`)
        }, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("labels.generic", { pt: "Avaliações", en: "Quiz" })), 1)
        ], 2),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => {
            _ctx.quizPaginated(false);
            _ctx.loader = true;
          }),
          class: _normalizeClass(`h-full w-[150px] flex justify-center items-center bg-transparent border-b-2 ${
            !_ctx.quizAnswer
              ? ' border-h-primary-500 text-h-primary-500'
              : 'border-[#0000] text-neutral-400'
          }`)
        }, _hoisted_12, 2)
      ]),
      (!_ctx.loader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_ctx.quizAnswer)
              ? (_openBlock(), _createBlock(_component_QuizAnswer, {
                  key: 0,
                  questions: _ctx.questions
                }, null, 8, ["questions"]))
              : _createCommentVNode("", true),
            (!_ctx.quizAnswer)
              ? (_openBlock(), _createBlock(_component_QuizChat, {
                  key: 1,
                  questions: _ctx.questionsChat
                }, null, 8, ["questions"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_Loader, { loader: _ctx.loader }, null, 8, ["loader"])
          ])),
      (!_ctx.loader && _ctx.params?.total)
        ? (_openBlock(), _createBlock(_component_Paginator, {
            key: 2,
            rows: _ctx.params?.size,
            totalRecords: _ctx.params?.total,
            onPage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.paginate($event)))
          }, null, 8, ["rows", "totalRecords"]))
        : _createCommentVNode("", true)
    ])
  ]))
}